import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/axiosConfig';

export const fetchAllTasks = createAsyncThunk(
  'tasks/fetchAll',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get("/projectRequestedTask");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const rejectTask = createAsyncThunk(
  'tasks/reject',
  async ({ quotationId, assignedPerson, managerNote }, thunkAPI) => {
    try {
      const response = await axiosInstance.put('/projectRequestedTask/reject', {
        quotationId,
        assignedPerson,
        managerNote,
      });
      return response.data; // returning entire response.data (you can modify if needed)
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

export const fetchTasksByPerson = createAsyncThunk(
  'tasks/fetchByPerson',
  async (assignedPerson, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/projectRequestedTask/task/${assignedPerson}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const createTask = createAsyncThunk(
  'tasks/create',
  async (taskData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/projectRequestedTask/task`, taskData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteTask = createAsyncThunk(
  'tasks/delete',
  async (id, thunkAPI) => {
    try {
      await axiosInstance.delete(`/projectRequestedTask/task/${id}`);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const projectRequestedTaskSlice = createSlice({
  name: 'projectRequestedTask',
  initialState: {
    tasks: [],
    requestedTasks : [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

    .addCase(fetchAllTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.requestedTasks = action.payload;
      })
      .addCase(fetchAllTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchTasksByPerson.fulfilled, (state, action) => {
        state.tasks = action.payload;
      })

      .addCase(createTask.fulfilled, (state, action) => {
        state.tasks.push(action.payload);
      })

      .addCase(deleteTask.fulfilled, (state, action) => {
        state.tasks = state.tasks.filter(task => task._id !== action.payload);
      })

      .addCase(rejectTask.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rejectTask.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(rejectTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  }
});

export default projectRequestedTaskSlice.reducer;
